import { z } from 'zod';

export const crmAnalyticsTicketSchema = z.object({
  id: z.string(),
  weekStart: z.iso.date().nullable(),
  weekEnd: z.iso.date().nullable(),
  source: z.enum(['sync/sync', 'postgres/generated']),
  availability: z.enum(['available', 'partial', 'unavailable']),
  createdTasks: z.number().nullable(),
  closedTasks: z.number().nullable(),
  averageHoursInWork: z.number().nullable(),
});

export const crmAnalyticsTicketsResponseSchema = z.object({
  items: z.array(crmAnalyticsTicketSchema),
  page: z.number().int().positive(),
  pageSize: z.number().int().positive(),
  totalItems: z.number().int().nonnegative(),
  totalPages: z.number().int().nonnegative(),
  lastSyncAt: z.string().nullable(),
});

export type CrmAnalyticsTicket = z.infer<typeof crmAnalyticsTicketSchema>;
export type CrmAnalyticsTicketsResponse = z.infer<typeof crmAnalyticsTicketsResponseSchema>;
